module.exports = __webpack_public_path__ + "static/media/youloose.e363726d.jpg";